import React, { Component } from "react";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { connect } from "react-redux";

import "./AnnotationBar.less";

import { getMessage } from "CONFIG/i18n";
import { isIPad13, isMobile } from 'react-device-detect';
//Component 
import PDFListModal from "./PdfListModal";
// Assets
import undo_img from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_undo.svg";
import redo_img from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_redo.svg";
import ic_eraser from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_eraser.svg";
import ic_eraser_object from "ASSETS/Images/ic_dustbin_unselected.svg";
import ic_eraser_object_selected from "ASSETS/Images/ic_dustbin_selected.svg";
import ic_freehand from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_freehand.svg";
import ic_text from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_text.svg";
import ic_circle from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_circle.svg";
import ic_line from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_line.svg";
import ic_line_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_line_selected.svg";
import ic_rectangle from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_rectangle.svg";
import ic_selection from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_selection.svg";
import ic_selection_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_selection_selected.svg";
import ic_text_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_text_selected.svg";
import ic_circle_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_circle_selected.svg";
import ic_freehand_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_freehand_selected.svg";
import ic_rectangle_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_rectangle_selected.svg";
import ic_eraser_selected from "ASSETS/Images/canvas_icons/Lookit_toolkit_icons/ic_eraser_selected.svg";
import download_img from "ASSETS/Images/ic_download.svg";

// Selectors
import {
  selectCurrentParticipantUniqueId,
  getDisableCanvasEdit,
} from "REDUX/Selector/SessionSelector";
import {
  getModules
} from "../../CommonComponents/Header/selectors";

// Constants
import { ANNOTATIONS, USER_ROLES, COLOR, 
  CANVAS_TYPES, floatedAnnotationBar } from "UTILS/Constants";
import { socketMessage } from "WEBSOCKET/constants";
import { isDesktopView } from '@/Utils/Utility';

class AnnotationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redo_icon: redo_img,
      undo_icon: undo_img,
      download_icon: download_img,
      collapse: false,
      imageUpload: false,
      showGroupedAnnotations: false,
      showPDFListModalFlag: false,
      renderPDFListModalFlag: false,
      showColorIcons: false,
      disableCanvasEdit: this.props.disableCanvasEdit ? this.props.disableCanvasEdit.isEnable || false : false,
      prevAnnotation : ANNOTATIONS.FREE_HAND.NAME,
      shapes: {
        [ANNOTATIONS.TEXT]: {
          title: "TEXT_DECORATION",
          unselected: ic_text,
          selected: ic_text_selected,
          isSelected: false
        },
        [ANNOTATIONS.CIRCLE]: {
          title: "CIRCLE",
          unselected: ic_circle,
          selected: ic_circle_selected,
          isSelected: false
        },
        [ANNOTATIONS.RECTANGLE]: {
          title: "RECTANGLE",
          unselected: ic_rectangle,
          selected: ic_rectangle_selected,
          isSelected: false
        },
  
        [ANNOTATIONS.LINE]: {
          title: "LINE",
          unselected: ic_line,
          selected: ic_line_selected,
          isSelected: false
        },
        [ANNOTATIONS.FREE_HAND.NAME]: {
          title: "DRAW",
          unselected: ic_freehand,
          selected: ic_freehand_selected,
          isSelected: false
        },
        [ANNOTATIONS.ERASER.NAME]: {
          title: "ERASER",
          unselected: ic_eraser,
          selected: ic_eraser_selected,
          isSelected: false
        },
        [ANNOTATIONS.ERASE_OBJECT]: {
          title: "ERASE_OBJECT",
          unselected: ic_eraser_object,
          selected: ic_eraser_object_selected,
          isSelected: false
        }
      }
    }

    this.handleChangeAnnotation = this.handleChangeAnnotation.bind(this);
  }

  componentDidMount() {
    if(isDesktopView(this.props.orientation) && !this.props.selectedAnnotation){
      this.setSelectedAnnotation();
    }
  }

  componentDidUpdate(prevProps) {
    // TODO: check if this block of code can be removed
    // if(this.props.isFrameLocked !== prevProps.isFrameLocked && this.props.isFrameLocked && this.props.selectedAnnotation === ANNOTATIONS.SELECTION) {
    //   this.props.handleChangeAnnotation(null)
    // }

    // if(this.props.isInkLocked !== prevProps.isInkLocked 
    //   && this.props.isInkLocked === true 
    //   && this.props.selectedAnnotation !== ANNOTATIONS.SELECTION
    //   && this.props.organiser !== this.props.uniqueId) {
    //   this.props.handleChangeAnnotation(null)
    // }

    if(this.props.allowEdit !== prevProps.allowEdit 
      && !this.props.allowEdit 
      && this.props.organiser !== this.props.uniqueId) {
      this.props.handleChangeAnnotation(null)
    }

    // in case of canvas switch from pdf to regular/image previously selected annotation should 
    // be active and usable 
    if(this.props.allowEdit !== prevProps.allowEdit 
      && this.props.allowEdit
      && !this.state.disableCanvasEdit
    ) {
      if(this.props.selectedAnnotationByAgent.annotation === ANNOTATIONS.FREE_HAND.NAME) {
        this.props.handleChangeAnnotation({
          value: ANNOTATIONS.FREE_HAND.NAME,
          color: this.props.selectedColor,
          width: ANNOTATIONS.FREE_HAND.WIDTH
        })
      } else if(this.props.selectedAnnotationByAgent.annotation === ANNOTATIONS.TEXT){
        this.props.handleChangeAnnotation(this.props.selectedAnnotationByAgent.annotation)
      } else if(this.props.selectedAnnotationByAgent.annotation === ANNOTATIONS.ERASER.NAME) {
        this.props.handleChangeAnnotation(ANNOTATIONS.ERASER.NAME)
      } else if(this.props.selectedAnnotationByAgent.annotation === ANNOTATIONS.ERASE_OBJECT) {
        this.props.handleChangeAnnotation(ANNOTATIONS.ERASE_OBJECT)
      }
    }

    if(this.props.selectedAnnotation !== prevProps.selectedAnnotation && this.state.shapes.hasOwnProperty(this.props.selectedAnnotation)){
      this.setState({prevAnnotation : this.props.selectedAnnotation})
    }

    // disable eraser and delete object if canvas is blank 
    if (prevProps.disableClearCanvas !== this.props.disableClearCanvas
      && this.props.disableClearCanvas
      && this.props.organiser === this.props.uniqueId
      && (this.props.selectedAnnotation === ANNOTATIONS.ERASER.NAME
        || this.props.selectedAnnotation === ANNOTATIONS.ERASE_OBJECT)
      && !this.state.disableCanvasEdit
    ) {
      this.removeAnnotation(this.props.selectedAnnotation);
    }
  }

  removeAnnotation = (annotation) => {
    let shapes = floatedAnnotationBar;
    shapes[annotation] = floatedAnnotationBar[annotation];
    Object.keys(floatedAnnotationBar).map(shape => {
      shapes[shape].isSelected = false;
    })

    // send WS message to add/remove annotation
    const {
      ADD_ANNOTATION,
      REMOVE_ANNOTATION
    } = socketMessage.subCategories.NOTIFICATION;
    const message = {
      data: {
        category: socketMessage.category.NOTIFICATION,
        action: shapes[annotation].isSelected
          ? ADD_ANNOTATION
          : REMOVE_ANNOTATION,
        annotation: annotation
      }
    };
    this.props.handleFloatedAnnotation(socketMessage.events.MESSAGE, message);
  }

  toggle = () => {
    this.setState(state => ({ collapse: !state.collapse }));
  };

  handleChangeAnnotation = event => {
    let notationType = _.isObject(event) ? event.value : event;
    if (this.props.selectedAnnotation !== notationType) {
      this.props.handleChangeAnnotation(event);
    } else {
      this.props.handleChangeAnnotation(null);
    }
  };

  handleChangeColor = color => {
    this.props.handleChangeColor(color);
    this.setState({showColorIcons: false});
  };

  handleChangeFontFamily = event => {
    this.props.handleChangeFontFamily(event);
  };

  undo = () => {
    this.setState({ undo_icon: undo_img })
    this.props.undo();
  };

  redo = () => {
    this.setState({ redo_icon: redo_img })
    this.props.redo();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { annotation } = nextProps.selectedAnnotationByAgent
    if (this.props.selectedAnnotationByAgent.annotation !== annotation) {
      if (this.props.userRole === USER_ROLES.USER && nextProps.allowEdit) {
        if (this.state.disableCanvasEdit) {
          this.handleChangeAnnotation(null);
          return;
        }
        if (this.props.selectedAnnotation !== ANNOTATIONS.SELECTION) {
          switch (annotation) {
            case ANNOTATIONS.CIRCLE:
            case ANNOTATIONS.RECTANGLE:
            case ANNOTATIONS.LINE:
              this.props.handleChangeAnnotation("remove");
              break;
            default:
              if (annotation === ANNOTATIONS.FREE_HAND.NAME) {
                this.props.handleChangeAnnotation({
                  value: ANNOTATIONS.FREE_HAND.NAME,
                  color: this.props.selectedColor,
                  width: ANNOTATIONS.FREE_HAND.WIDTH
                });
                return;
              }
              if(annotation !== ANNOTATIONS.SELECTION){
                this.props.handleChangeAnnotation(annotation);
              }
              break;
          }
        }
      } else if (this.props.userRole !== USER_ROLES.USER) {
        if (this.state.disableCanvasEdit) {
          this.handleChangeAnnotation(null);
          return;          
        }
        if (annotation === ANNOTATIONS.FREE_HAND.NAME) {
          this.handleChangeAnnotation({
            value: ANNOTATIONS.FREE_HAND.NAME,
            color: this.props.selectedColor,
            width: ANNOTATIONS.FREE_HAND.WIDTH
          });
          return;
        }
        this.props.handleChangeAnnotation(annotation);
      }
    }
  }

  setSelectedAnnotation() {
    const { annotation } = this.props.selectedAnnotationByAgent
    if (this.props.userRole === USER_ROLES.USER && this.props.allowEdit) {
      if (this.state.disableCanvasEdit) {
        this.handleChangeAnnotation(null);
        return;
      }
      switch (annotation) {
        case ANNOTATIONS.CIRCLE:
        case ANNOTATIONS.RECTANGLE:
        case ANNOTATIONS.LINE:
          this.props.handleChangeAnnotation("remove");
          break;
        default:
          if (annotation === ANNOTATIONS.FREE_HAND.NAME) {
            this.props.handleChangeAnnotation({
              value: ANNOTATIONS.FREE_HAND.NAME,
              color: this.props.selectedColor,
              width: ANNOTATIONS.FREE_HAND.WIDTH
            });
            return;
          }
          this.props.handleChangeAnnotation(annotation);

          break;
      }
    } else if (this.props.userRole !== USER_ROLES.USER) {
      if (this.state.disableCanvasEdit) {
        this.handleChangeAnnotation(null);
        return;          
      }
      if (annotation === ANNOTATIONS.FREE_HAND.NAME) {
        this.handleChangeAnnotation({
          value: ANNOTATIONS.FREE_HAND.NAME,
          color: this.props.selectedColor,
          width: ANNOTATIONS.FREE_HAND.WIDTH
        });
        return;
      }
      this.props.handleChangeAnnotation(annotation);
    }
  }

  showFloatedAnnotationBar = () => {
    if (this.state.showColorIcons) {
      this.setState({ showColorIcons: false });
    }
    this.props.showFloatedAnnotationBar();
  }

  hasAgentGaveControl = () => {
    if (!_.isEmpty(this.props.selectedAnnotationByAgent)
      && this.props.activeCanvasData.canvasType !== CANVAS_TYPES.PDF) {
      const { isSelected, annotation } = this.props.selectedAnnotationByAgent;
      if (this.props.organiser !== this.props.uniqueId) {
        // console.log(annotation === annotations && this.props.allowEdit)
        return this.props.guestAnnotations.lastIndexOf(annotation) !== -1 && this.props.allowEdit;
      }
    }
  }
  
  setUndoIcon = () => {
    this.setState({ undo_icon: undo_img })
  }
  setRedoIcon = () => {
    this.setState({ redo_icon: redo_img })
  }

  showFloatedColorIcons = () => {
    if(this.props.showGroupedAnnotations){
      this.showFloatedAnnotationBar();
    }
    this.setState({ showColorIcons: !this.state.showColorIcons });
  }

  handleChangeGuestAnnotation = () => {
    if (!this.props.selectedAnnotation || this.props.selectedAnnotation === ANNOTATIONS.SELECTION) {
      this.props.handleChangeAnnotation(this.props.selectedAnnotationByAgent.annotation);
    } else if (this.props.guestAnnotations.indexOf(this.props.selectedAnnotation) !== -1) {
      this.props.handleChangeAnnotation(null);
    }
  };

  handleFloatedAnnotationWSMessage = (annotation, isSelected) => {
    const {
      ADD_ANNOTATION,
      REMOVE_ANNOTATION
    } = socketMessage.subCategories.NOTIFICATION;
    const message = {
      data: {
        category: socketMessage.category.NOTIFICATION,
        action: isSelected
          ? ADD_ANNOTATION
          : REMOVE_ANNOTATION,
        annotation: annotation
      }
    };
    this.props.handleFloatedAnnotation(socketMessage.events.MESSAGE, message);
  }

  handleChangeSelection = () => {
    const selection =ANNOTATIONS.SELECTION;
    if (this.props.selectedAnnotation === selection) {
      this.handleChangeAnnotation(null);
      this.handleFloatedAnnotationWSMessage(selection);
    } else {
      this.handleChangeAnnotation(selection);
      this.handleFloatedAnnotationWSMessage(selection, true);
    }
  }

  render() {
    let annotationBarVisibility = ((this.props.showAudioVideoComponent && !isMobile)
      || this.props.activeCanvasData.canvasType !== CANVAS_TYPES.PDF
      || this.props.isPresenter
      || this.props.organiser === this.props.uniqueId)
      ? " "
      : " displayNone"
    const isSelectedAnnotation = (this.props.guestAnnotations.indexOf(this.props.selectedAnnotation) !== -1 && this.props.organiser !== this.props.uniqueId) ||
      (Object.keys(this.state.shapes).indexOf(this.props.selectedAnnotation) !== -1 && this.props.organiser === this.props.uniqueId);

    const isSelectedSelection = this.props.selectedAnnotation === ANNOTATIONS.SELECTION;
    return (
      !this.state.disableCanvasEdit &&
      this.props.activeCanvasData.canvasType !== CANVAS_TYPES.PDF &&
      <div
        className={"annotationBar" + annotationBarVisibility}
        id="annotationBar" >
        {this.props.organiser === this.props.uniqueId &&
          <>
            {/** redo icon */
              <div
                className="annotationBarIcon"
                onClick={
                  this.props.organiser !== this.props.uniqueId || !this.props.undoEnabled
                    ? () => { }
                    : this.undo
                }
                onDrag={this.setUndoIcon}>
                <img
                  src={this.state.undo_icon}
                  alt="undo"
                  className={this.props.undoEnabled
                    ? "cursorPointer undoOnClick"
                    : "isDisabled"}
                  title={getMessage("UNDO")}
                />
              </div>
            }
            { /** undo icon */
              <div className="annotationBarIcon">
                <img
                  src={this.state.redo_icon}
                  alt="redo"
                  className={this.props.redoEnabled
                    ? "cursorPointer redoOnClick"
                    : "isDisabled"}
                  title={getMessage("REDO")}
                  onClick={
                    this.props.organiser !== this.props.uniqueId || !this.props.redoEnabled
                      ? () => { }
                      : this.redo
                  }
                  onDrag={this.setRedoIcon}
                />
              </div>
            }
          </>
        }
        {/** color icon  */
          (this.props.organiser === this.props.uniqueId ||
            this.hasAgentGaveControl()) &&
          <>
            <div className="annotationBarIcon selectToggleIcon" onClick={this.showFloatedColorIcons}>
              <span className="circleIcon" style={{ backgroundColor: this.props.selectedColor }}></span>
              {this.props.organiser === this.props.uniqueId &&
                <span className="toggle"></span>
              }
            </div>
            { /** color selection popup  */
              this.props.organiser === this.props.uniqueId &&
              this.state.showColorIcons &&
              <ul className="selectPopupIcons">
                {Object.keys(COLOR).map((key) => {
                  return (
                    <li
                      key={key}
                      className={`selectPopupIcon ${this.props.selectedColor === COLOR[key] && "iconSelected"}`}
                      onClick={() => this.handleChangeColor(COLOR[key])}
                      title={getMessage(key)}
                    >
                      <span className="circleIcon" style={{ backgroundColor: key }}></span>
                    </li>
                  );
                })
                }
              </ul>
            }</>
        }
        {/** annotation icon */
          (this.props.organiser === this.props.uniqueId ||
            this.hasAgentGaveControl()) &&
          <div
            className={`annotationBarIcon selectToggleIcon 
            ${isSelectedAnnotation && "iconSelected"}`}
            onClick={this.props.organiser === this.props.uniqueId 
              ? this.showFloatedAnnotationBar
              : this.handleChangeGuestAnnotation
            }
          >
            <img
              src={
                this.state.shapes[this.props.selectedAnnotationByAgent.annotation]
                  ? isSelectedAnnotation
                    ? this.state.shapes[this.props.selectedAnnotationByAgent.annotation].selected
                    : this.state.shapes[this.props.selectedAnnotationByAgent.annotation].unselected
                  : isSelectedAnnotation 
                    ? this.state.shapes[this.state.prevAnnotation].selected
                    : this.state.shapes[this.state.prevAnnotation].unselected
              }
              title={getMessage("ANNOTATIONS")}
              alt="GroupedNotations"
            />
            {this.props.organiser === this.props.uniqueId &&
              <span className="toggle"></span>
            }
          </div>
        }
        {/** selection icon */
          <div className={`annotationBarIcon ${isSelectedSelection && "iconSelected"}`} style={{display: !this.props.allowEdit ? 'none' : 'block'}}>
            <img
              src={isSelectedSelection 
                ? ic_selection_selected
                : ic_selection
              }
              title={getMessage("SELECTION")}
              alt="select"
              className={this.props.isFrameLocked && this.props.organiser !== this.props.uniqueId ?
                "" : " cursorPointer"}
              onClick={
                this.props.isFrameLocked && this.props.organiser !== this.props.uniqueId
                  ? () => { }
                  : this.handleChangeSelection
              }
            />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    uniqueId: selectCurrentParticipantUniqueId(state),
    modulesAvailable: getModules(state),
    disableCanvasEdit: getDisableCanvasEdit(state),
  };
};

export default connect(mapStateToProps)(AnnotationBar);